import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';
/**
 * Interface for confirmation dialog component properties
 */

/**
 * Represents a confirmation dialog
 */
export const ConfirmationDialog = props => {
  const handleCancel = () => props.onClose(true);

  const handleOk = () => props.onClose(false);

  return /*#__PURE__*/React.createElement(Dialog, {
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: "md",
    "aria-labelledby": "confirmation-dialog-title",
    "aria-describedby": "confirmation-dialog-description",
    open: props.isOpen
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "confirmation-dialog-title"
  }, props.dialogTitle), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    dangerouslySetInnerHTML: {
      __html: props.children
    },
    id: "confirmation-dialog-description"
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleOk,
    variant: "contained",
    color: "primary"
  }, props.okButtonText || 'ok'), /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancel
  }, props.cancelButtonText || 'cancel')));
};
//# sourceMappingURL=confirmation-dialog.js.map